export const GATED_ACTIONS = {
  NoAction: 1,
  SetCustomNumber: 2,
  Register10DLC: 3,
  Blocked: 4,
  ComplianceViolationBlocked: 5,
};